// strategy_edit.js

var CROPPER;
$(document).ready(function () {
    initPhotoUpload();
    initTinyMCE();
    initForms();
});


function initForms() {
    // Enable "diry form" checking on the form
    $('form').areYouSure();
}

function initTinyMCE() {
    tinymce.init({ 
        selector: 'textarea[name="description"]',
        menubar: false,
        plugins: 'link',
        // skip the default toolbar and specify only what we want here
        toolbar: "bold, italic, underline | link",
        // always keep changes in sync
        setup: function (editor) {
            editor.on('dirty', function() {
                tinymce.triggerSave();
                $('form').trigger('checkform.areYouSure');
            })
            editor.on('change', function () {
                tinymce.triggerSave();
            });
        }
    });
}

// init the image cropper when the image files are selected
function initPhotoUpload() {
    // this is done in an each() so we can use more-meaningful variable names (more readable) and less .siblings() code (less fragile)
    // the file input itself receives a data('cropper') so we can refer to it from external tools, e.g. the buttons
    $('form input[type="file"][name^="image"]').each(function () {
        // define our elements, trying to use selectors that won't sprawl out and catch other future buttons accidentally
        var $input = $(this);
        var $cropwrap  = $input.closest('div').find('.imageCropperAndButtons');
        var $cropcanv  = $input.closest('div').find('.imageCropper');
        var $btncrop   = $input.closest('div').find('input.imageCropper-crop');
        var $btnin     = $input.closest('div').find('input.imageCropper-zoomIn');
        var $btnout    = $input.closest('div').find('input.imageCropper-zoomOut');
        var $thumb     = $input.siblings('img.croppedThumbnail'); // sorry future buttons!
        var $b64text   = $input.closest('div').find('input[type="hidden"]');
        var $btnclear  = $('input[data-role="image_clear"]');

        // start by hiding the image cropper tool; it will be shown when the file input is triggered, and hidden again when an image is successfully cropped
        $cropwrap.hide();

        // on selecting a file, trigger the cropper and show the wrapper with buttons and all
        $input.on('change', function(){
            var size = this.files[0].size; // check that the file isn't terribly large; if it's this far over-resolution they could lag the browser
            if (size > 10 * 1048576) {
                $(this).val('');
                alert("That image is too large (over 10 MB).\nPlease try reducing the image size and/or resolution to bring it under 10 MB.");
                return false;
            }

            var fileinput = $(this);
            var reader    = new FileReader();
            reader.onload = function(e) {
                $cropwrap.show();
                CROPPER = $cropcanv.cropbox({
                    thumbBox: '.imageCropperCanvas',
                    imgSrc: e.target.result
                });
            }
            reader.readAsDataURL(this.files[0]);
            $(this).val('');
        });

        $btnin.on('click', function() {
            CROPPER.zoomIn();
        });
        $btnout.on('click', function() {
            CROPPER.zoomOut();
        });
        $btncrop.on('click', function() {
            // fetch the base64 version and load it into both a visible thumbnail and a not-visible text input
            var b64 = CROPPER.getAvatar();
            $thumb.prop('src',b64).attr({style: "display:inline-block;"});
            $b64text.val(b64).trigger('change');
            $cropwrap.hide();

            // show the clear image button, now that we have something to clear
            $btnclear.show();

            // clear the file input so we don't actually upload an image file
            // then hide the file input so the users aren't confused by "No file selected"
            // just let the thumbnail speak for itself
            $input.val('').hide();
        });
    });

    // The Clear image buttons are tagged with a image number e.g. image2
    // these should clear the corresponding imageX_base64 hidden field, and hide the img.croppedThumbnail, and also toggle the "Not present" text
    // see also the input[type="file"][name^="image"] event setup, which reverses this complicated mess: populate a thumbnail, populate the hidden box, show the Clear Image button, ...
    $('input[type="button"][data-role="image_clear"]').click(function () {
        var image = $(this).attr('data-image');
        $('img.croppedThumbnail[data-image="'+image+'"]').prop('src','about:blank').hide();
        $('input[type="hidden"][name="'+image+'_base64"').val('').trigger('change');
        // hide this button
        $(this).hide();
        // show the file input again, so they can add another if they wish
        $('input[type="file"][name="'+ image + '"]').css({'display':'inline'});

    });
}